<template>
  <v-form v-model="isFormValid" ref="form">
    <v-text-field :label="$t('full_name')" :rules="rulesRequired" v-model="form.name" small dense outlined :error-messages="fieldErrors.name"></v-text-field>
  </v-form>
</template>

<script>

import Utils from '@/utils/utils'

export default {
  name: 'BillingCustomer',
  computed: {
    rulesRequired () {
      return [v => !!v || this.$t('field_required')]
    }
  },
  data: () => ({
    isFormValid: false,
    fieldErrors: {},
    form: {
      name: ''
    }
  }),
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  watch: {
    'form.name' () {
      this.clearFieldError('name')
    }
  },
  methods: {
    clearFieldErrors () {
      this.fieldErrors = {}
    },
    clearFieldError (fieldName) {
      if (this.fieldErrors[fieldName]) {
        this.$set(this.fieldErrors, fieldName, null)
      }
    },
    setFieldErrors (errors) {
      this.fieldErrors = { ...errors }
    },
    validate () {
      this.clearFieldErrors()
      return this.$refs.form ? this.$refs.form.validate() : this.isFormValid
    },
    async submit () {
      try {
        if (this.form.id) {
          return await this.$store.dispatch('updateCustomer', { customer: this.form })
        }
        return await this.$store.dispatch('createCustomer', { customer: this.form })
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data) {
          this.setFieldErrors(Utils.parseFieldErrors(error.response.data))
        }
        throw error
      }
    }
  },
  created () {
    this.form = { ...this.customer }
  }
}

</script>

<style lang="sass" scoped>
</style>
